import { j as s } from "../../../../jsx-runtime-B6kdoens.js";
import { forwardRef as l } from "react";
import { I as o } from "../../../../IconBase-CxZyIWw2.js";
const t = l((a, e) => /* @__PURE__ */ s.jsx(
  o,
  {
    ref: e,
    ...a,
    image: (r) => /* @__PURE__ */ s.jsxs(
      "svg",
      {
        xmlns: "http://www.w3.org/2000/svg",
        width: 17,
        height: 16,
        fill: "none",
        viewBox: "0 0 17 16",
        ...r,
        children: [
          /* @__PURE__ */ s.jsx(
            "mask",
            {
              id: "mask0_2974_3464",
              width: 17,
              height: 16,
              x: 1,
              y: 0,
              maskUnits: "userSpaceOnUse",
              style: {
                maskType: "alpha"
              },
              children: /* @__PURE__ */ s.jsx(
                "path",
                {
                  fill: "currentColor",
                  d: "M1.752 16c-.14 0-.27-.04-.39-.11a.74.74 0 0 1-.36-.64V4c0-.41.34-.75.75-.75s.75.34.75.75v10.04L14.572 8 1.412 1.42a.75.75 0 0 1-.33-1.01c.18-.37.64-.51 1.01-.33l14.5 7.25c.25.13.41.39.41.67s-.16.54-.41.67l-14.5 7.25c-.11.05-.23.08-.34.08"
                }
              )
            }
          ),
          /* @__PURE__ */ s.jsx("g", { mask: "url(#mask0_2974_3464)", children: /* @__PURE__ */ s.jsx("path", { fill: "currentColor", d: "M1 0h16v16H1z" }) })
        ]
      }
    )
  }
));
t.displayName = "AgencyPlayIcon";
export {
  t as AgencyPlayIcon,
  t as default
};
//# sourceMappingURL=index.js.map
